export enum SnackBarTheme {
    INFO = 'snack-bar-info',
    SUCCESS = 'snack-bar-success',
    ERROR = 'snack-bar-error',
    WARNING = 'snack-bar-warning'
}

export interface DataSnackBar {
    snackBarSummary: string;
    snackBarDetail?: string;
    snackBarDetailList?: string[];
    snackBarTheme: SnackBarTheme;
}